import { createFileRoute, redirect } from "@tanstack/react-router";
import { encodeRedirectPath } from "@/i18n/route-manifest";

export const Route = createFileRoute("/")({
  beforeLoad: ({ location }) => {
    // Use href (not to/params + search object) so client redirect resolution
    // never stringifies a null-prototype search object during hydration.
    const hash = location.hash ? `#${location.hash.replace(/^#/, "")}` : "";
    throw redirect({
      href: `${encodeRedirectPath("/en-ca")}${location.searchStr ?? ""}${hash}`,
      statusCode: 301,
      replace: true,
    });
  },
  component: () => null,
});
